
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Auditer vos campagnes SEA : étapes pour booster vos performances",
    description:
      "Optimisez vos campagnes Google Ads avec un audit complet. Découvrez les étapes clés avec ALEO pour analyser et améliorer vos performances Google Ads !",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
